
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { BzHeading, BzTab, BzTabs, BzInputText, BzLoader, BzDropdown } from '../../components';
import NewsContent from './NewsContent';
import { useLocation } from 'react-router';
import { APP_INFO_PARAMS, DASHBOARD_EXPLORE_CATEGORY, LOCATIONS } from '../../utils/global_variables';
import { getApiExchangeNameFromMktSegId, getAppInfoData, getMktSegIdFromMappedMktSegId, handleScripUnsubScriptionOnUnMount } from '../../utils/global_functions';

import { useDispatch, useSelector } from 'react-redux';
import { announcementsExchange, clearNewsState, clearannouncementState, getNews, hotPursuitData, newsSectors, scripWiseHoldingsNews, sectorWiseNews, updateActiveNewsTab, updateAnnouncementNewsStatus, updateAnnouncementType, updateNewsSearchText, updateNewsVisibleScipsAction, updateSectorCode } from '../../redux/actions/news';
import ZeroStates from '../ZeroStates';
import { sendTouchlineRequest } from '../../apis/web_socket';
import NewsDetailsModal from './NewsDetailsModal';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import NewsHoldingCards from './NewsHoldingCards';
import { _getTabs } from '../../controllers/news';
import { useUnload } from '../../hooks';



const nPage = 1;
const scripNewsPage = 5;
const jtenantToken = 1;
const newsItemCount = 20;


const News = forwardRef(({ ...props }, ref) => {


    const location = useLocation();
    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);
    const newsSector = useSelector(state => state?.news?.newsSector);
    const objReduxNewsScrips = useSelector(state => state?.news?.objReduxNewsScrips);
    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);
    const arrNewsData = useSelector(state => state?.news?.arrNewsData);
    const arrAnnouncement = useSelector(state => state?.news?.arrAnnouncement);
    const isLimtReached = useSelector(state => state?.news?.isLimtReached);
    const arrHoldingNews = useSelector(state => state?.news?.holdingNews);
    const arrHoldings = useSelector(state => state?.holdings?.holdingsScrips);
    const sectorCode = useSelector(state => state?.news?.sectorCode);
    const activeTab = useSelector(state => state?.news?.activeNewsTab);
    const announcementType = useSelector(state => state?.news?.announcementType);
    const searchText = useSelector(state => state?.news?.newsSearchText);
    const isAnnouncementAPIFailed = useSelector(state => state?.news?.isAnnouncementAPIFailed);
    const isHotPursuitAPIFailed = useSelector(state => state?.news?.isHotPursuitAPIFailed);
    const isNewsAPIFailed = useSelector(state => state?.news?.isNewsAPIFailed);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start
    const bIsNewsAPIPending = useSelector(state => state?.news?.bIsNewsAPIPending);
    const bIsHotPursuitAPIPending = useSelector(state => state?.news?.bIsHotPursuitAPIPending);
    const bIsAnnouncementAPIPending = useSelector(state => state?.news?.bIsAnnouncementAPIPending);
    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End
    const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE, appInfo);
    let nItems = getAppInfoData(APP_INFO_PARAMS.APP_HOTPURSUIT_SCRIP_COUNT, appInfo);

    const [arrActiveNews, setArrActiveNews] = useState([]);
    const [objActiveNewsType, setObjActiveNewsType] = useState({});
    const [selectedNews, setSelectedNews] = useState({});
    useEffect(() => {
        if (nItems.length <= 0) {
            nItems = '10';
        }
        else {
        }
    }, [nItems]);

    const newsTypes = _getTabs(nCMOTMode, arrAnnouncement, arrNewsData, arrHotPursuitData);

    // Hari K : 24-08-2023 BT-107439 dashboard-news holding news -start

    useEffect(() => {
        if (arrHoldings?.length && arrHoldingNews?.length <= 0) {
            arrHoldings?.forEach((each) => {
                dispatch(scripWiseHoldingsNews(each.nToken, getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(each.nMarketSegmentId)), scripNewsPage, jtenantToken));
            });
        } else { }
    }, [arrHoldings, arrHoldingNews, dispatch]);
    // Hari K : 24-08-2023 BT-107439 dashboard-news holding news -ends

    useEffect(() => {
        const arrActiveTab = newsTypes?.length && newsTypes?.filter((each) => Number( each.id) === Number(activeTab));
        if (arrActiveTab?.length) {
            setObjActiveNewsType(arrActiveTab[0]);
        } else { }
    }, [activeTab, arrHotPursuitData, arrAnnouncement, arrNewsData]);

    useEffect(() => {
        if (searchText?.length > 0) {
            const filteredNews = objActiveNewsType?.data?.filter((each) => each?.news_content?.toLowerCase().includes(searchText?.toLowerCase()));
            setArrActiveNews(filteredNews);
        } else {
            setArrActiveNews(objActiveNewsType?.data);
        }
    }, [searchText, objActiveNewsType]);

    const [arrFilteredHoldingNews, setArrFilteredHoldingNews] = useState([]);

    useEffect(() => {
        if (searchText?.length > 0) {
            const filteredNews = arrHoldingNews?.filter((each) => each?.ScripData_BSE?.Symbol?.toLowerCase().includes(searchText?.toLowerCase()) || each?.ScripData_NSE?.Symbol?.toLowerCase().includes(searchText?.toLowerCase()));
            setArrFilteredHoldingNews(filteredNews);
        } else {
            setArrFilteredHoldingNews(arrHoldingNews);
        }
    }, [searchText, arrHoldingNews]);

    const filterNewsType = async (newsTypeId) => {
        await dispatch(updateNewsSearchText(""));
        await dispatch(updateActiveNewsTab(newsTypeId));
        targetDiv.current.scrollTop = 0;
        await dispatch(updateAnnouncementNewsStatus(''));
    };

    const filterNewsSectorWise = async (sectorCode) => {
        await dispatch(updateNewsSearchText(""));
        await dispatch(updateSectorCode(sectorCode));
        await dispatch(clearNewsState());
        await dispatch(sectorWiseNews(sectorCode, nPage, newsItemCount, jtenantToken));
    };

    const filterAnnouncements = async (exchangeType) => {
        await dispatch(updateNewsSearchText(""));
        await dispatch(updateAnnouncementType((exchangeType)));
        await dispatch(clearannouncementState());
        await dispatch(announcementsExchange(exchangeType, nPage, newsItemCount, jtenantToken));
    };

    const handleExpandCollapse = useCallback(() => {
        dispatch(clearannouncementState());
        dispatch(clearNewsState());
        if (props.isExpandCollapse) {
            props.setIsExpandCollapse(false);
            props.setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.MAIN);
        }
        else {
            props.setIsExpandCollapse(true);
            props.setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.NEWS);
        }
    }, [dispatch]);
    const onSearchChange = (value) => {
        dispatch(updateNewsSearchText(value));
    };







    useEffect(() => {
        dispatch(newsSectors(jtenantToken));
        dispatch(hotPursuitData(nItems, jtenantToken));
        dispatch(getNews());
        dispatch(scripWiseHoldingsNews(jtenantToken));
        dispatch(announcementsExchange(announcementType, nPage, newsItemCount, jtenantToken));
    }, [dispatch]);

    // Hari k:25-01-2024 :Bt-107439 - dashboard news-start
    useEffect(() => {
        if (sectorCode?.length && !arrNewsData?.length) {
            dispatch(sectorWiseNews(sectorCode, nPage, newsItemCount, jtenantToken));
        } else { }
    }, [sectorCode, dispatch]);
    // Hari k:25-01-2024 :Bt-107439 - dashboard news-end


    // Hari K:02-11-2023: maintaining individual state for page nation of news and announcement tabs
    const [newspageNo, setNewsPageNo] = useState(2);
    const [announcementPageNo, setAnnouncementPageNo] = useState(2);

    const targetDiv = useRef(null);

    const onScroll = () => {
        handleDontMissSubscription();
        if (objActiveNewsType.tabKey === 'news' || objActiveNewsType.tabKey === 'announcements') {
            handleScroll();
        } else { }
    };

    const [isNearBottom, handleScroll] = useInfiniteScroll(targetDiv, 170);


    const scrollContainerObserver1 = (containerRef, sublevel = false) => {
        return new Promise((resolve) => {
            const observer = new IntersectionObserver((entries) => {
                const visible = entries?.filter((entry) => entry?.isIntersecting)?.map((entry) => entry?.target?.id);
                resolve(visible);
            }, {
                root: containerRef?.current,
                threshold: 1
            });
            const container = containerRef?.current;
            if (container && !sublevel) {
                Array?.from(container.children[0]?.children)?.forEach((child) => observer?.observe(child));
            }
            if (container && sublevel) {
                const innerContainer = container?.children[1]?.children[0]?.children[0]?.children[0]?.children[0];
                Array?.from(innerContainer?.children)?.forEach((child) => observer?.observe(child));
            }
        });

    };

    const [objScripsRequest, setObjScripsRequest] = useState({});
    useEffect(() => {
        if (Object?.keys(objScripsRequest)?.length > 0) {
            dispatch(updateNewsVisibleScipsAction({ ...objScripsRequest }));
        }
    }, [objScripsRequest]);
    const handleDontMissSubscription = useCallback(async () => {
        let newdIs = await scrollContainerObserver1(targetDiv, location?.pathname === LOCATIONS.WATCHLIST ? false : true);
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = newdIs.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });
                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            return { ...objpreviosScripsCopy };
        });
    }, []);

    const handleNewsUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objReduxNewsScrips, 'news');
    }, [objReduxNewsScrips, dispatch]);

    useEffect(() => {
        return () => {
            handleNewsUnSubscription();
        };
    }, []);

    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- Start
    useUnload(() => {
        handleNewsUnSubscription();
    });
    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- End

    useEffect(() => {
        if (objActiveNewsType?.tabKey === "hot_pursuit" || objActiveNewsType?.data?.length > 0) {
            handleDontMissSubscription();
        } else { }
    }, [objActiveNewsType, handleDontMissSubscription]);


    useEffect(() => {
        if (isNearBottom) {
            if (objActiveNewsType.tabKey === 'news' && isLimtReached === false) {
                dispatch(sectorWiseNews(sectorCode, newspageNo, newsItemCount, jtenantToken));
                setNewsPageNo(prev => prev + 1); // Hari K:02-11-2023: BT-107439 :  seting newsPageNo states
            }
            if (objActiveNewsType.tabKey === 'announcements' && isLimtReached === false) {
                dispatch(announcementsExchange(announcementType, announcementPageNo, newsItemCount, jtenantToken));
                setAnnouncementPageNo(prev => prev + 1); // Hari K:02-11-2023: BT-107439 :  setting announcementPageNo states
            }
        } else { }
    }, [isNearBottom]);

    useImperativeHandle(ref, () => ({
        filterNewsSectorWise,
        filterAnnouncements,
    }));



    const isModalOpen = useMemo(() => {
        if (modals['NEWS_DETAILS']) {
            return true;
        } else if (modals['HOT_PURSUIT_DATA']) {
            return true;
        } else { return false; }
    }, [modals]);

    return (
        <>
            {
                location.pathname === LOCATIONS.PORTFOLIO ?
                    <Container fluid className='p-0'>
                        {/* Hari K:30-07-2024 commented the code to show only holdings news-start */}
                        <Row className='g-0 my-1 align-items-center justify-content-between'>
                            {/* <Col md="auto">
                                <div className='d-flex justify-content-start align-items-center subnav-container bdr-none'>
                                    <div className='submenu-wrapper d-flex justify-content-end align-items-center'>
                                        {
                                            newsTypes && newsTypes?.map((newsType, i) => (
                                                <BzChip key={i} className={`submenuItem ${newsType?.id === activeTab ? 'active' : null}`} onClick={() => { filterNewsType(newsType?.id); }}>
                                                    {newsType?.name}
                                                </BzChip>
                                            ))
                                        }
                                    </div>

                                </div>
                            </Col>                            
                            <Col md={3}>
                                {
                                    objActiveNewsType.name === 'News' ?
                                        <div className='d-flex align-items-center'>
                                            <div className='font-medium font-size2 color-text text-nowrap me-2'>Sector:</div>
                                            <div className='Bzselect-dropdown'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle className='btn-default'>
                                                        {
                                                        newsSector?.filter(each=>each?.SectorCode===sectorCode)?.[0]?.SectorName?.length>22
                                                        ?
                                                            `${newsSector?.filter(each=>each?.SectorCode===sectorCode)?.[0]?.SectorName?.slice(0,22)}...`
                                                        :
                                                            newsSector?.filter(each=>each?.SectorCode===sectorCode)?.[0]?.SectorName
                                                        }
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {
                                                            newsSector?.length > 0 && newsSector?.map((each, i) => (
                                                                <Dropdown.Item onClick={e => filterNewsSectorWise(each?.SectorCode)} key={each?.SectorCode} value={each?.SectorCode}>{each.SectorName}</Dropdown.Item>
                                                            ))
                                                        }
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </div> : null
                                }
                                {
                                    objActiveNewsType.name === 'Announcements' ?
                                        <div className='d-flex align-items-center justify-content-end'>
                                            <div className='font-medium font-size2 color-text text-nowrap me-2'>Exchange:</div>
                                            <div className='Bzselect-dropdown ms-1'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle className='btn-default'>{announcementType}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {objLoginSession?.data?.exchanges?.includes('NSE_EQ') || (!objLoginSession?.data?.exchanges?.includes('NSE_CUR') && !objLoginSession?.data?.exchanges?.includes('BSE_EQ') && !objLoginSession?.data?.exchanges?.includes('NSE_CUR')) ? <Dropdown.Item onClick={(e) => filterAnnouncements('NSE')}>NSE</Dropdown.Item> : null}
                                                        {objLoginSession?.data?.exchanges?.includes('BSE_EQ') ?  <Dropdown.Item onClick={(e) => filterAnnouncements('BSE')}>BSE</Dropdown.Item> : null}
                                                        {objLoginSession?.data?.exchanges?.includes('NSE_CUR') ? <Dropdown.Item onClick={(e) => filterAnnouncements('NSECDS')}>NSECDS</Dropdown.Item> : null}
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>                                           
                                        </div> : null
                                }
                            </Col>                            */}

                            <Col md={8}></Col>
                            <Col md={4} className='d-flex justify-content-end'>
                                <div className={`position-relative w-70 ${arrHoldingNews?.length > 0 ? '' : 'div-disabled'}`}>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText value={searchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                </div>
                            </Col>
                        </Row>
                        {/* Hari K:30-07-2024 commented the code to show only holdings news-end */}
                        <Row className='g-0'>
                            <Col>
                                <div className='portfolio-newstabs-scroll'>
                                    {objActiveNewsType?.name === 'Hot Pursuit' ?
                                        <Row className='g-0'>
                                            <Col>
                                                <div className='newscard-nowrap position-relative'>
                                                    {
                                                        (arrFilteredHoldingNews?.length > 0 && arrFilteredHoldingNews?.map((each, i) => (
                                                            <NewsHoldingCards arrHolding={each} id={i} />
                                                        )))
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        : ''}
                                    <Row className='g-0 position-relative'>
                                        <Col>
                                            <div className='vertical-scroll-wrap'>
                                                {(arrFilteredHoldingNews?.length <= 0 && searchText.length > 0) ?
                                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                                        <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                    </div> : (arrFilteredHoldingNews?.length <= 0 && searchText.length <= 0) ?
                                                        <div className='zero-state-alerts zero-state-alerts-lg'>
                                                            <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                                            <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon with the latest news and updates related to Stock Market</div>
                                                        </div> : null}
                                            </div>
                                            {/* Hari K:30-07-2024 commented the code to show only holdings news-start */}
                                            {/* <div className='vertical-scroll-wrap'>
                                                {
                                                    arrActiveNews?.length > 0 ? arrActiveNews?.map((objActiveNewsData, i) => (
                                                        <NewsContent key={i} objActiveNewsData={objActiveNewsData} tab={objActiveNewsType?.name} />
                                                    )) :
                                                        (arrActiveNews?.length <= 0 && searchText.length > 0) ?
                                                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                                                <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                            </div>
                                                            // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start
                                                            : (bIsNewsAPIPending && objActiveNewsType.name === 'News') || (bIsHotPursuitAPIPending && objActiveNewsType?.name === 'Hot Pursuit') || (bIsAnnouncementAPIPending && objActiveNewsType.name === 'Announcements') ?
                                                                <div className='d-flex justify-content-center align-items-center data-loader'>
                                                                    <BzLoader spinner={bIsNewsAPIPending || bIsHotPursuitAPIPending || bIsAnnouncementAPIPending} spinnerContent={"Fetching Details"} />
                                                                </div> :
                                                                (arrActiveNews?.length <= 0 && searchText.length <= 0) && (isNewsAPIFailed === true && objActiveNewsType.name === 'News') || (isAnnouncementAPIFailed === true && objActiveNewsType.name === 'Announcements') || (isHotPursuitAPIFailed == true && objActiveNewsType?.name === 'Hot Pursuit') ?
                                                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                                                        <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                                                        <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon with the latest news and updates related to Stock Market</div>
                                                                    </div>
                                                                    :
                                                                    arrActiveNews?.length <= 0 && (!bIsNewsAPIPending && !isNewsAPIFailed && objActiveNewsType.name === 'News') || (!bIsHotPursuitAPIPending && !isHotPursuitAPIFailed && objActiveNewsType?.name === 'Hot Pursuit') || (!bIsAnnouncementAPIPending && !isAnnouncementAPIFailed && objActiveNewsType.name === 'Announcements') ?
                                                                        <ZeroStates subText="No Data Found" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' /> : null
                                                    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End

                                                }
                                            </div> */}
                                            {/* Hari K:30-07-2024 commented the code to show only holdings news-end */}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container >
                    : location.pathname === LOCATIONS.WATCHLIST ?
                        (
                            <Container fluid className='p-0 px-3' >
                                <Row>
                                    {objActiveNewsType?.name === 'Hot Pursuit' ?
                                        <div className='newscard-wrap'>
                                            {
                                                (arrFilteredHoldingNews?.length > 0 && arrFilteredHoldingNews?.map((each, i) => (
                                                    <NewsHoldingCards arrHolding={each} id={i} />
                                                )))
                                            }
                                        </div>
                                        : null}
                                </Row>
                                <Row className='g-0' ref={targetDiv} onScroll={onScroll}>
                                    <Col>
                                        {
                                            arrActiveNews?.length > 0 ? arrActiveNews?.map((objActiveNewsData, i) => (
                                                <NewsContent key={i} objActiveNewsData={objActiveNewsData} tab={objActiveNewsType?.name} setSelectedNews={setSelectedNews} />
                                            )) : (arrActiveNews?.length <= 0 && searchText.length > 0) ?
                                                <div className='zero-state-alerts zero-state-alerts-xl'>
                                                    <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                </div>
                                                : (arrActiveNews?.length <= 0 && searchText.length <= 0) && (bIsNewsAPIPending === false && isNewsAPIFailed === true && objActiveNewsType.name === 'News') || (bIsAnnouncementAPIPending === false && isAnnouncementAPIFailed === true && objActiveNewsType.name === 'Announcements') || (bIsHotPursuitAPIPending === false && isHotPursuitAPIFailed == true && objActiveNewsType?.name === 'Hot Pursuit') ?
                                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                                        <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                                        <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon with the latest news and updates related to Stock Market</div>
                                                    </div>
                                                    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start
                                                    : (bIsNewsAPIPending && objActiveNewsType.name === 'News') || (bIsHotPursuitAPIPending && objActiveNewsType?.name === 'Hot Pursuit') || (bIsAnnouncementAPIPending && objActiveNewsType.name === 'Announcements') ?
                                                        <div className='d-flex justify-content-center align-items-center data-loader'>
                                                            <BzLoader spinner={bIsNewsAPIPending || bIsHotPursuitAPIPending || bIsAnnouncementAPIPending} spinnerContent={"Fetching Details"} />
                                                        </div> : arrActiveNews?.length <= 0 && (bIsNewsAPIPending === false && isNewsAPIFailed === false && objActiveNewsType.name === 'News') || (bIsHotPursuitAPIPending === false && isHotPursuitAPIFailed === false && objActiveNewsType?.name === 'Hot Pursuit') || (bIsAnnouncementAPIPending === false && isAnnouncementAPIFailed === false && objActiveNewsType.name === 'Announcements') ?
                                                            <ZeroStates subText="No Data Found" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' /> : null
                                            // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End

                                        }
                                    </Col>
                                </Row>
                            </Container>
                        ) :
                        location.pathname === LOCATIONS.DASHBOARD ?
                            (
                                <Container fluid className={props.isExpandCollapse ? 'p-0 px-3 dashboard-content-wrapper news-expanded' : 'g-0'}>
                                    <div className='dashboard-news'>
                                        <Row className={`${props.isExpandCollapse ? '' : 'px-3'} g-0 dashboard-cards-header align-items-center`}>
                                            <Col md={2} className='d-flex justify-content-start'>
                                                <div className='heading-border'>
                                                    <BzHeading data-testid="test-heading" className='font-medium font-size8 color-text text-uppercase line-height-1 ms-3'>News</BzHeading>
                                                </div>
                                            </Col>
                                            <Col md={8} className='d-flex justify-content-center'>
                                                <div className='horizontal-scroll-wrap'>
                                                    <BzTabs className='nav nav-tabs text-center pt-2'>
                                                        {
                                                            newsTypes && newsTypes?.map((newsType) => (
                                                                <BzTab key={newsType?.id} tabKey={newsType.id} isActive={newsType?.id === activeTab} className={`nav-link text-capitalize ${newsType?.id === activeTab ? 'active' : null}`} onClick={() => { filterNewsType(newsType?.id); }}>
                                                                    {newsType?.name}
                                                                </BzTab>
                                                            ))
                                                        }
                                                    </BzTabs>
                                                </div>
                                            </Col>
                                            <Col md={2} className='d-flex justify-content-end'>
                                                <div data-testid="news-expand" className='background-icon' onClick={handleExpandCollapse}>
                                                    <div data-testid="expand-icon" className={`icon-16 icon-dark ${props.isExpandCollapse ? 'icon-collapse' : 'icon-expand'}`}></div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className='dashboard-cards-container p-3'>
                                            {
                                                <Container fluid className='p-0'>
                                                    <Row className='g-0 mb-2'>
                                                        <Col md={props.isExpandCollapse ? 7 : ""} className='d-flex justify-content-start align-items-center'>
                                                            {
                                                                objActiveNewsType.name === 'News' &&
                                                                <>
                                                                    <div className='font-medium font-size2 color-text text-nowrap me-2'>Sector:</div>
                                                                    <div className='Bzselect-dropdown'>
                                                                        <BzDropdown>
                                                                            <Dropdown.Toggle className='btn-default' data-testid="test-selectedSector">
                                                                                {
                                                                                    newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName?.length > 30
                                                                                        ?
                                                                                        `${newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName?.slice(0, 30)}...`
                                                                                        :
                                                                                        newsSector?.filter(each => each?.SectorCode === sectorCode)?.[0]?.SectorName
                                                                                }
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                {
                                                                                    newsSector?.length > 0 && newsSector?.map((each, i) => (
                                                                                        <Dropdown.Item onClick={e => filterNewsSectorWise(each?.SectorCode)} data-testid="test-sectors" key={each?.SectorCode} value={each?.SectorCode}>{each.SectorName}</Dropdown.Item>
                                                                                    ))
                                                                                }
                                                                            </Dropdown.Menu>
                                                                        </BzDropdown>
                                                                    </div>
                                                                </>
                                                            }
                                                            {
                                                                objActiveNewsType.name === 'Announcements' &&
                                                                <>
                                                                    <div className='font-medium font-size2 color-text text-nowrap me-2'>Exchange:</div>
                                                                    <div className='Bzselect-dropdown ms-1'>
                                                                        <BzDropdown>
                                                                            <Dropdown.Toggle className='btn-default' data-testid="test-selectedExchange">{announcementType}</Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                {objLoginSession?.data?.exchanges?.includes('NSE_EQ') || (!objLoginSession?.data?.exchanges?.includes('NSE_CUR') && !objLoginSession?.data?.exchanges?.includes('BSE_EQ') && !objLoginSession?.data?.exchanges?.includes('NSE_CUR')) ? <Dropdown.Item data-testid="test-exchanges" onClick={(e) => filterAnnouncements('NSE')}>NSE</Dropdown.Item> : null}
                                                                                {objLoginSession?.data?.exchanges?.includes('BSE_EQ') ? <Dropdown.Item data-testid="test-exchanges" onClick={(e) => filterAnnouncements('BSE')}>BSE</Dropdown.Item> : null}
                                                                                {objLoginSession?.data?.exchanges?.includes('NSE_CUR') ? <Dropdown.Item data-testid="test-exchanges" onClick={(e) => filterAnnouncements('NSECDS')}>NSECDS</Dropdown.Item> : null}
                                                                            </Dropdown.Menu>
                                                                        </BzDropdown>
                                                                    </div>
                                                                </>
                                                            }
                                                        </Col>
                                                        <Col md={1}>&nbsp;</Col>
                                                        {objActiveNewsType?.data?.length > 0 ?
                                                            <Col className='d-flex justify-content-end'>
                                                                <div className='position-relative w-100'>
                                                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                                    <BzInputText value={searchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                                                </div>
                                                            </Col>
                                                            : null}
                                                    </Row>
                                                </Container>
                                            }
                                            <div className='news-card-wrapper position-relative' ref={targetDiv} onScroll={onScroll}>
                                                <Row className='g-0'>
                                                    <Col>
                                                        <div className='newscard-wrap'>
                                                            {objActiveNewsType?.name === 'Hot Pursuit' && objActiveNewsType?.data?.length > 0 &&
                                                                (arrFilteredHoldingNews?.length > 0 && arrFilteredHoldingNews?.map((each, i) => (
                                                                    <NewsHoldingCards arrHolding={each} key={i} />
                                                                )))
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col>
                                                        <div className='vertical-scroll-wrap'>
                                                            {
                                                                arrActiveNews?.length > 0 ?
                                                                    <Container fluid className='p-0'>
                                                                        <div className='transparent-card-wrap'>
                                                                            {
                                                                                arrActiveNews?.map((objActiveNewsData, i) => (
                                                                                    <NewsContent key={i} objActiveNewsData={objActiveNewsData} tab={objActiveNewsType?.name} setSelectedNews={setSelectedNews} />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </Container>
                                                                    :
                                                                    (arrActiveNews?.length <= 0 && searchText.length > 0) ?
                                                                        <div className='zero-state-alerts zero-state-alerts-lg'>
                                                                            <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                                        </div>
                                                                        // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start
                                                                        : (bIsNewsAPIPending && objActiveNewsType.name === 'News') || (bIsHotPursuitAPIPending && objActiveNewsType?.name === 'Hot Pursuit') || (bIsAnnouncementAPIPending && objActiveNewsType.name === 'Announcements') ?
                                                                            <div className='d-flex justify-content-center align-items-center data-loader'>
                                                                                <BzLoader spinner={bIsNewsAPIPending || bIsHotPursuitAPIPending || bIsAnnouncementAPIPending} spinnerContent={"Fetching Details"} />
                                                                            </div>
                                                                            : (arrActiveNews?.length <= 0 && searchText.length <= 0) && (isNewsAPIFailed === true && objActiveNewsType.name === 'News') || (isAnnouncementAPIFailed === true && objActiveNewsType.name === 'Announcements') || (isHotPursuitAPIFailed === true && objActiveNewsType?.name === 'Hot Pursuit') ?
                                                                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                                                                    <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                                                                    <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon with the latest news and updates related to Stock Market</div>
                                                                                </div>
                                                                                : arrActiveNews?.length <= 0 && (bIsNewsAPIPending === false && isNewsAPIFailed === false && objActiveNewsType.name === 'News') || (bIsHotPursuitAPIPending === false && isHotPursuitAPIFailed === false && objActiveNewsType?.name === 'Hot Pursuit') || (bIsAnnouncementAPIPending === false && isAnnouncementAPIFailed === false && objActiveNewsType.name === 'Announcements') ?
                                                                                    <ZeroStates subText="No Data Found" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' /> : null
                                                                // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End

                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </Container>
                            ) : null
            }
            {isModalOpen && <NewsDetailsModal selectedNews={selectedNews} setSelectedNews={setSelectedNews} tab={objActiveNewsType?.name} />}
        </>
    );
}
);

export default memo(News);